import { IHeader } from "../../common/components/AgGrid/index";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import { ISCUser } from "../../common/salescredit/salescredit-role-types";
import { AgFormat } from "../../common/utils/agGridFormat";
import {
  ICprSalescreditRevenueKpi,
  ICprSalesCreditSearchCriteria,
  INbiSalescreditResponse,
} from "../../common/utils/types";
import { ISalesByProductData } from "./types";

export function getMapping(
  data: IGenericAggregateResponse,
  user: ISCUser
): ISalesByProductData | undefined {
  if (!data.aggregates || data.aggregates.length === 0) {
    return undefined;
  }
  const profileDictionary = new SCProfileDictionary();
  const profileKpis = profileDictionary.GetGridFields(user.Profile);
  const rows: any[] = [];

  for (const item of data.aggregates) {
    const product1 =
      item.dimensionAttributeValues[SCAttributes.SC_PRODUCT_LEVEL1];
    const row: { [field: string]: string | number } = {};
    row[SCAttributes.SC_PRODUCT_LEVEL1] = product1;

    const product2 =
      item.dimensionAttributeValues[SCAttributes.SC_PRODUCT_LEVEL2];
    row[SCAttributes.SC_PRODUCT_LEVEL2] = product2;

    const product3 =
      item.dimensionAttributeValues[SCAttributes.SC_PRODUCT_LEVEL3];
    row[SCAttributes.SC_PRODUCT_LEVEL3] = product3;

    const product4 =
      item.dimensionAttributeValues[SCAttributes.SC_PRODUCT_LEVEL4];
    row[SCAttributes.SC_PRODUCT_LEVEL4] = product4;

    for (const kpiRaw of profileKpis) {
      row[kpiRaw.Kpi] = item.indicatorKpiValues[kpiRaw.Kpi];
    }
    rows.push(row);
  }
  return {
    Headers: buildHeaders(user),
    Rows: rows,
  };
}

export function buildHeaders(user: ISCUser): IHeader[] {
  const headers: IHeader[] = [
    {
      field: SCAttributes.SC_PRODUCT_LEVEL1,
      headerName: "Product level 1",
      hide: true,
      rowGroup: true,
    },

    {
      field: SCAttributes.SC_PRODUCT_LEVEL2,
      headerName: "Product level 2",
      hide: true,
      rowGroup: true,
    },

    {
      field: SCAttributes.SC_PRODUCT_LEVEL3,
      headerName: "Product level 3",
      hide: true,
      rowGroup: true,
    },
    {
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: {
        /*        checkbox: false,
        padding: 10,
        suppressCount: true,*/
      },
      cellStyle: AgFormat.AgRowGroupHeaderStyle,
      field: SCAttributes.SC_PRODUCT_LEVEL4,
      headerName: "Product",
      hide: false,
      showRowGroup: true,
      suppressSizeToFit: true,
      suppressToolPanel: true,
      width: 200,
    },
  ];

  const profileDictionary = new SCProfileDictionary();
  const headerKpis = profileDictionary.GetGridFields(user.Profile);

  for (const kpiRaw of headerKpis) {
    headers.push(kpiRaw.HeaderFormat);
  }
  return headers;
}
